"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._setObjectInStorage = exports._getObjectFromStorage = exports.Storage = void 0;
const Log_1 = require("./Log");
const SafeJs_1 = require("./SafeJs");
const inMemoryStore = {};
const _resolve = (input) => Promise.resolve(input);
const _inMemoryProvider = {
    _getProviderName: () => 'InMemory',
    _getItemSync: (key) => inMemoryStore[key] ? inMemoryStore[key] : null,
    _getItem: (key) => _resolve(inMemoryStore[key] ? inMemoryStore[key] : null),
    _setItem: (key, value) => ((inMemoryStore[key] = value), _resolve()),
    _removeItem: (key) => (delete inMemoryStore[key], _resolve()),
    _getAllKeys: () => _resolve(Object.keys(inMemoryStore)),
};
let _localStorageProvider = null;
try {
    const win = (0, SafeJs_1._getWindowSafe)();
    if (win &&
        win.localStorage &&
        typeof win.localStorage.getItem === 'function') {
        _localStorageProvider = {
            _getProviderName: () => 'LocalStorage',
            _getItemSync: (key) => win.localStorage.getItem(key),
            _getItem: (key) => _resolve(win.localStorage.getItem(key)),
            _setItem: (key, value) => (win.localStorage.setItem(key, value), _resolve()),
            _removeItem: (key) => (win.localStorage.removeItem(key), _resolve()),
            _getAllKeys: () => _resolve(Object.keys(win.localStorage)),
        };
    }
}
catch (error) {
    Log_1.Log.warn('Failed to setup localStorageProvider.');
}
let _main = _localStorageProvider !== null && _localStorageProvider !== void 0 ? _localStorageProvider : _inMemoryProvider;
let _current = _main;
function _inMemoryBreaker(get) {
    try {
        return get();
    }
    catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            exports.Storage._setProvider(_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
exports.Storage = {
    _getProviderName: () => _current._getProviderName(),
    _getItem: (key) => __awaiter(void 0, void 0, void 0, function* () { return _inMemoryBreaker(() => _current._getItem(key)); }),
    _getItemSync: (key) => _inMemoryBreaker(() => _current._getItemSync ? _current._getItemSync(key) : null),
    _setItem: (key, value) => _current._setItem(key, value),
    _removeItem: (key) => _current._removeItem(key),
    _getAllKeys: () => _current._getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider) => {
        _main = newProvider;
        _current = newProvider;
    },
    _setDisabled: (isDisabled) => {
        if (isDisabled) {
            _current = _inMemoryProvider;
        }
        else {
            _current = _main;
        }
    },
};
function _getObjectFromStorage(key) {
    return __awaiter(this, void 0, void 0, function* () {
        const value = yield exports.Storage._getItem(key);
        return JSON.parse(value !== null && value !== void 0 ? value : 'null');
    });
}
exports._getObjectFromStorage = _getObjectFromStorage;
function _setObjectInStorage(key, obj) {
    return __awaiter(this, void 0, void 0, function* () {
        yield exports.Storage._setItem(key, JSON.stringify(obj));
    });
}
exports._setObjectInStorage = _setObjectInStorage;
